<template>
  <div class="import-montos-transferir">
    <b-row>
      <b-col cols="12" xl="12">
        <b-card header="Importar Montos a Transferir">
          <b-form>
            <app-cliente
              label="Cliente"
              :nombre="clienteNombre"
              :labelCols="labelCols"
              :lista="clientesList"
              @updated="clienteActualizado">
            </app-cliente>  

            <b-form-group
              label="Evento"
              label-for="evento"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarEvento">
                  <b-input-group-text>
                    <i class="fa fa-search"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="evento"
                  :value="eventoNombre"
                  readonly
                  type="text"/>
              </b-input-group>
            </b-form-group>

            <app-evento-etapa
              label="Etapa"
              :nombre="eventoEtapaNombre"
              labelOption="Todas las etapas"
              :labelCols="labelCols"
              :lista="eventoEtapasList"
              :readOnly="!existsEventoEtapas"
              @updated="eventoEtapaActualizado">
            </app-evento-etapa> 

            <b-form-group
                label="Archivo"
                label-for="file"
                :label-cols="labelCols"
                horizontal
                description="Listado de montos a transferir en formato csv (separados por coma)">
              <b-form-file 
                v-model="file" 
                class="mt-3" 
                accept=".csv" 
                placeholder="Seleccione un archivo o arrastrelo hasta aquí">
              </b-form-file>
            </b-form-group>
          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="importarMontosTransferir">Importar</b-button>
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="cancelar">Cancelar</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="searchEventoModal" 
        title="Seleccionar Evento"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="search-modal">
      <app-search-evento
        :clienteId="clienteId"
        @eventoSeleccionado="eventoSeleccionado">
      </app-search-evento>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Cliente from '../shared/abmSelect.vue';
import SearchEvento from '../eventos/SearchList';
import EventoEtapa from '../shared/abmSelect.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'importMontosTransferir/getField',
  mutationType: 'importMontosTransferir/updateField',
});

export default {
  name: 'ImportMontosTransferir',
  components: {
    appCliente: Cliente,
    appSearchEvento: SearchEvento,
    appEventoEtapa: EventoEtapa,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal,
  ],
  data () {
    return {
      clientes: [],
      clientesList: [],

      labelCols: 2,
      loadingClientes: false
    }
  },
  computed: {
    ...mapFields([
      'clienteId',
      'cliente',
      'clienteNombre',
      'evento',
      'eventoNombre',
      'fechaDesde',
      'fechaHasta',
      'eventoEtapa',
      'eventoEtapaNombre',

      'eventoEtapas',
      'eventoEtapasList',
      'file',

      'registros',
      'errores'
    ]),
    existsEventoEtapas() {
      if (this.eventoEtapasList) {
        return this.eventoEtapasList.length != 0;
      }

      return false;
    }
  },  
  created() {
    this.showSpinner();
    this.loadingClientes = true;
    this.$store.dispatch('importMontosTransferir/inicializar')
      .then(() => this.getDatosAdicionales())
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  methods: {
    getDatosAdicionales() {
      this.$store.dispatch('clientes/getList')
        .then(() => {
          this.clientes = this.$store.getters['clientes/list']
          this.clientesList = this.$store.getters['clientes/selectList']
          this.loadingClientes = false;
        })
        .catch(() => this.showErrorMsj(new Error('Se produjo un error al recuperar la lista de clientes')))
    },
    importarMontosTransferir () {
      this.showSpinner();
      this.$store.dispatch('importMontosTransferir/importarMontosTransferir')
        .then(() => {
          // const errores = this.$store.getters['importMontosTransferir/errores'];

          if (this.errores.length > 0) {
            /* Exportamos el listado de errores */
            this.exportarErroresCSV(this.errores);
          }

          if (this.registros != 0) {
            let msj = `Se importaron correctamente ${this.registros} registros`;

            if (this.errores.length > 0) {
              msj += ` y se descargó el log de errores.`;
            }

            this.showModalMsj(msj, this.cancelar, this.cancelar, 'light');
          } else {
            let msj = `No se importaron registros`;

            if (this.errores.length > 0) {
              msj += ` y se descargó el log de errores`;
            }

            msj += `. Verifique el formato y la información del archivo e intente nuevamente.`;

            this.showModalMsj(msj, null, null, 'light');
          }
        })
        .catch(error => this.showErrorMsj (error))
        .finally(() => this.hideSpinner());
    },
    cancelar() {
      this.$store.dispatch('importMontosTransferir/inicializar')
        .catch(error => this.showErrorMsj(error));
    },
    clienteActualizado(clienteNombre) {
      if (!this.loadingClientes) {
        this.clienteNombre = clienteNombre;

        let cliente;
        if (clienteNombre) {
          cliente = this.getSelected(this.clientes, clienteNombre);
        }
        this.$store.dispatch('importMontosTransferir/setCliente', cliente);

        // this.clienteValido = null;
        // this.clienteInvalidoMsj = '';
      }
    },
    seleccionarEvento() {
      if (this.clienteId != 0) {
        this.$refs.searchEventoModal.show();
      } else {
        this.showErrorMsj(new Error('Debe seleccionar el cliente en primer término'))
      }
    },
    eventoSeleccionado(evento) {
      this.$refs.searchEventoModal.hide();
      if (evento) {
        this.showSpinner();
        this.$store.dispatch('importMontosTransferir/setEvento', evento)
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    eventoEtapaActualizado(eventoEtapaNombre) {
      let eventoEtapa;
      if (eventoEtapaNombre) {
        eventoEtapa = this.getSelected(this.eventoEtapas, eventoEtapaNombre);
      }
      this.$store.dispatch('importMontosTransferir/setEventoEtapa', eventoEtapa);
    },
    exportarErroresCSV(errores) {
      const encabezado = 'Linea,Mensaje';
      const filas = errores.map(e => {
        const linea = `${String(e.linea).replace(/"/g, '""')}`;
        const mensaje = `${String(e.error).replace(/"/g, '""')}`;
        return `${linea},${mensaje}`;
      });
      const csv = [encabezado, ...filas].join('\r\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', 'errores_importacion.csv');
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
  },
  watch: {
  },
}
</script>

<style>
  .import-montos-transferir .custom-file.b-form-file {
    margin-top: 0 !important;
  }
</style>
